<template lang="pug">
.container-fluid
  // Page Heading
  .d-sm-flex.align-items-center.justify-content-between.mb-4
    h1.h3.mb-0.text-gray-800 User Profile
  // Content Row
  .row
    // Area Chart
    .col-xl-12.col-lg-12
      .card.shadow.mb-4
        // Card Header - Dropdown
        .card-header.py-3.d-flex.flex-row.align-items-center.justify-content-between
          h6.m-0.font-weight-bold.text-primary Edit User Info                
        .card-body.text-center
          .col-12
            label Full name: {{fullname}}
          .col-12.mb-4
            input(type="text" v-model="newFullName")
          .col-12
            label Email: {{email}}
          .col-12.mb-4
            input(type="email" v-model="newEmail")
          .col-12
            label Password:
          .col-12.mb-4
            input(type="password" v-model="newPassword")
          button.btn.btn-primary(v-on:click="postUser") Update
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: 'UserProfile',
  props: {

  },
  metaInfo: {
    title: 'User Profile',
  },
  data:function(){
    return{
      newFullName:null,
      newEmail:null,
      newPassword:null,
    }
  },
  computed: mapState(['email', 'fullname']),
  methods:{
    ...mapActions(['updateUser']),
    postUser(){

      var bodyFormData = new FormData();
      bodyFormData.append('email',this.newEmail)
      bodyFormData.append('password',this.newPassword)
      bodyFormData.append('fullname',this.newFullName)
      
      this.axios.post('/rp/server/profile', bodyFormData)
      .then(response =>{
        if(response.data.error){
          this.flash(response.data.error.message,'error')
        }        
      })

    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 
</style>
